import React, { PropsWithChildren } from "react";
import cs from "classnames";

export const NameAndValueRow = ({
  name,
  value,
  className,
}: PropsWithChildren<{
  name: string;
  value: string | number;
  className?: string;
}>) => {
  return (
    <div className={cs("NameAndValueRow", className)}>
      <span>{name}</span>: {value}
    </div>
  );
};
